module.exports = __webpack_public_path__ + "static/9.3_ancient_america_olmec-2b96388fc04c8ba79018a4eed54c3f2e.pdf";